import Asset from '@ltypes/asset';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const stockSlice = createSlice({
    name: 'stock',
    initialState: null as Array<Asset>|null,
    reducers: {
        updateStocksList: (state, action: PayloadAction<Array<Asset>>) => {
            return action.payload;
        },
    }
});

export const { updateStocksList } = stockSlice.actions;

export default stockSlice.reducer;